import { useEffect, useState } from 'react';

export const useLargeScreen = (breakpoint = 768) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkIsLargeScreen = () => {
      setIsLargeScreen(window.innerWidth > breakpoint);
    };

    checkIsLargeScreen();
    window.addEventListener('resize', checkIsLargeScreen);
    return () => {
      window.removeEventListener('resize', checkIsLargeScreen);
    };
  }, [breakpoint]);

  return isLargeScreen;
};
